import React, { PropTypes, PureComponent } from 'react';
import { Button, OnClickOut, Popover } from 'react-fast-ui';
import PopoverTitle from '../layout/PopoverTitle';

export default class ConfirmationButton extends PureComponent {
  static propTypes = {
    caption: PropTypes.node,
    onConfirm: PropTypes.func.isRequired,
    buttonComponent: PropTypes.func
  };

  static defaultProps = {
    buttonComponent: Button
  };

  state = {
    confirming: false
  };

  handleConfirm = () => this.setState({ confirming: false }, this.props.onConfirm);

  renderConfirm() {
    const { type } = this.props;

    return (
      <div className="text-nowrap">
        <PopoverTitle>{this.getTitle()}</PopoverTitle>
        <div className="pd-sm">
          <Button text="Cancel" onClick={() => this.setState({ confirming: false })}/>
          <Button className="mg-left-md" text="Confirm" type={type} onClick={this.handleConfirm}/>
        </div>
      </div>
    );
  }

  changeConfirming = confirming => {
    if (this.state.confirming !== confirming) {
      this.setState({ confirming });
    }
  };

  close = () => this.changeConfirming(false);
  open = () => this.changeConfirming(true);

  getTitle() {
    const { caption } = this.props;
    let text;

    if (caption) {
      text = caption;
    } else {
      text = 'Are you sure?';
    }

    return <div className="text-center">{text}</div>;
  }

  render() {
    const { disabled, placement, buttonComponent: ButtonComponent } = this.props;
    const { confirming } = this.state;

    return (
      <OnClickOut onClickOut={this.close}>
        <Popover
          style={{ zIndex: 1001 }} content={this.renderConfirm()} open={confirming && !disabled}
          placement={placement}
        >
          <span>
            <ButtonComponent {...this.props} disabled={disabled || confirming} onClick={this.open}/>
          </span>
        </Popover>
      </OnClickOut>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/buttons/ConfirmButton.jsx